<template>
  <!-- --------------------------------------------------------- -->
  <!-- ---------------- Page Header ----------------------------- -->
  <!-- --------------------------------------------------------- -->

  <div class="mainPageDiv">

    <div class="pageHeader">
      Company Information
    </div>

    <span class="subHeaderFont">Create New Company:</span>

    <div @click="handleCreateRecord" class="material-icons forIconNewRecord text-success" data-tooltip="tooltip"
      title="Create a new Company">
      add_card
    </div>

    <div class="radioheaderadjustment radioFirstLeftMargin">
      <input type="radio" @click="handleActiveRadioClick" id="radioActiveButtonID" name="recordsToShow" checked aria-label="Show Active Records"/>

      <label class="lableMargin subHeaderFont" for="setup">Active</label>
    </div>

    <div class="radioheaderadjustment radioOtherLeftMargin">
      <input type="radio" @click="handleAllRadioClick" id="radioAllButtonID" name="recordsToShow" aria-label="Show All Records" />

      <label class="lableMargin subHeaderFont" for="setup">All</label>
    </div>

    <!-- --------------------------------------------------------- -->
    <!-- ---------------- Data Grid ------------------------------ -->
    <!-- --------------------------------------------------------- -->

    <ApplicationGrid :GridData="gridTime" RowsPerPageText="Company Records" SearchText="Search Company Records:"
      :EnablePaging="true" :EnableSearching="true" :EnableSorting="true" :HeaderArrays="headerArrays"
      :LeftRightSlots="leftRightSlots" :RowsPerPageArray="rowsPerPageArray" :EnableSettings="false"
      :EnableRecordsInfoDisplay="true">

      <!-- ------------------------------------------------------------------------------- -->
      <!-- -------------- RIGHT Email Verified (rightHeader10/rightData10) --------------- -->
      <!-- ------------------------------------------------------------------------------- -->

      <template v-slot:rightHeader10>
        <span class="actionsHeader">Active</span>
      </template>

      <template v-slot:rightData10="slotArgs">

        <div class="activeAgency" :id="'Agency1_' + slotArgs.itemArg['agency_ID']" data-tooltip="tooltip"
          title="Click to toggle Active status">

          <input type="checkbox" :checked="slotArgs.itemArg['isActive']" @click="handleActiveLinkClick(slotArgs)" aria-label="Check box to make the record Active">

        </div>

      </template>

      <!-- ------------------------------------------------------------------------ -->
      <!-- -------------- RIGHT Action (rightHeader11/rightData11) ---------------- -->
      <!-- ------------------------------------------------------------------------ -->

      <template v-slot:rightHeader11>
        <span class="actionsHeader">Edit</span>
      </template>

      <template v-slot:rightData11="slotArgs">

        <span @click="handleEditRecord(slotArgs)" class="material-icons text-primary editIconSlot" data-tooltip="tooltip"
          title="Edit Record">
          edit
        </span>

      </template>

      <!-- ------------------------------------------------------------------------------- -->
      <!-- -------------- SLOT END ------------------------------------------------------- -->
      <!-- ------------------------------------------------------------------------------- -->


    </ApplicationGrid>
  </div>

  <!-- ----------------------------------------------------------------------------- -->
  <!-- --------------------------- MODAL Update-Create start ------------------------ -->
  <!-- ------------------------------------------------------------------------------ -->

  <div id="xmodal-main-ID" class="xmodal-container-main">
    <div class="xmodal-container-content">

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- HEADER ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="header-primary headerMainContainer">
        <div style="display: inline-block;">&nbsp;</div>
        <div style="color: white; display: inline-block">{{ modalTitle }}</div>
        <div class="cancelModalX" @click="CloseModalUpdateCreate"
          style="margin-right: 10px; color: white; display: inline-block; text-align: right; align-items: end;">X</div>
      </div>

      <hr class="xmodal-hr-top" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- FORM ------------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-container-form">
        <!-- ------- Record Id -->
        <div v-if="createSelected == false" class="xmodal-content-justify-right xmodal-control-labels"
          data-tooltip="tooltip" title="Database Record ID">Record Id</div>
        <div v-if="createSelected == false" class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="companyIdTxtBx" v-model="companyId" type="text" size="9" disabled aria-label="Record ID"/>
        </div>
        <!-- ------- Company Name -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Name">
          Company Name:<span v-if="nameUndefined || nameNotUnique" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="NameTxtBx" v-model="companyName" type="text" :size="controlWith_large"  aria-label="Company Name" aria-live="polite"/>
        </div>

        <!-- ------- Address 1 -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Address 1">
          Address 1:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="companyAddress1" type="text" :size="controlWith_large"  aria-label="Company Address 1" aria-live="polite"/>
        </div>

        <!-- ------- Address 2 -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Address 2">
          Address 2:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="companyAddress2" type="text" :size="controlWith_large"  aria-label="Company Address 2" aria-live="polite"/>
        </div>

        <!-- ------- City -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company City">
          City:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="companyCity" type="text" :size="controlWith_large"  aria-label="City" aria-live="polite"/>
        </div>

        <!-- ------- State -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company State">
          State:
        </div>

        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <select id="CountryId" class="xmodal-content-justify-left xmodal-dropdownlist-padding" v-model="selectedStateId"
            style="margin: 0px" aria-label="Select State">
            <option v-for="item in stateList" :value="item.usStateId" :key="item.usStateId">
              {{ item.stateName }}
            </option>
          </select>

        </div>

        <!-- ------- Country -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Country">
          Country:
        </div>

        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <select id="CountryId" class="xmodal-content-justify-left xmodal-dropdownlist-padding"
            v-model="selectedCountryID" style="margin: 0px"  aria-label="Select Country">
            <option v-for="item in countryList" :value="item.countryId" :key="item.countryId">
              {{ item.countryName }}
            </option>
          </select>

        </div>

        <!-- ------- Postal -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Postal">
          Postal:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="companyPostal" type="text" :size="controlWith_small"  aria-label="Postal Code" aria-live="polite"/>
        </div>

        <!-- ------- Telephone -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company Telephone">
          Telephone:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="companyPhone" type="text" :size="controlWith_small"  aria-label="Company Telephone" aria-live="polite"/>
        </div>

        <!-- ------- NAICS -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company NAICS">
          NAICS Code:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="naisc" type="text" :size="controlWith_small"  aria-label="Company NAICS Code" aria-live="polite"/>
        </div>

        <!-- ------- CAGE -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip" title="Company CAGE Code">
          CAGE Code:
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">
          <input id="acronymTxtBx" v-model="cage" type="text" :size="controlWith_small"  aria-label="Company CAGE code" aria-live="polite"/>
        </div>

        <!-- ------- Active Radio Buttons -->
        <div class="xmodal-content-justify-right xmodal-control-labels" data-tooltip="tooltip"
          title="Active state of company">
          Active:<span v-if="activeNotSelected" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div class="xmodal-content-justify-left xmodal-textbox-padding">

          <input type="radio" :checked="((isActive == true) && (createSelected == false))" id="radioActiveID"
            name="activeRadioButtons" class="vertAlignMiddle" aria-label="Record is Active"/>

          <label class="labelAlign" for="radioActiveID">Yes</label>

          <input type="radio" :checked="((isActive == false) && (createSelected == false))" id="radioInactiveID"
            name="activeRadioButtons" class="vertAlignMiddle radioButtonLeftMargin" aria-label="Record is Not Active"/>

          <label class="labelAlign" for="radioInactiveID">No</label>

        </div>

        <!-- ------- Arming Authority list -->
        <div v-if="createSelected == false" class="xmodal-content-justify-right xmodal-control-labels"
          data-tooltip="tooltip" title="Date last updated">
          Last Updated:<span v-if="armingAuthorityAcronymUndefined" class="xmodal-required-asterisk text-danger">*</span>
        </div>
        <div v-if="createSelected == false" class="xmodal-content-justify-left xmodal-textbox-padding">
          <span>{{ updateDate }}</span>
        </div>

      </div>

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Validation ------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <hr v-if="validationErrorsFound" class="xmodal-hr-bottom" />
      <div v-if="validationErrorsFound" class="text-danger xmodal-outer-div">Required fields indicated by asterisk(s).
        Make selections for the following:
        <div class="xmodal-inner-div">
          <ul class="xmodal-li-validation">
            <li v-if="nameUndefined"> Company Name </li>
            <li v-if="nameNotUnique"> Company Name already exists </li>
            <li v-if="activeNotSelected"> Please specify whether or not the Company is Active </li>
          </ul>
        </div>
      </div>

      <hr class="xmodal-hr-bottom" />

      <!-- ---------------------------------------------------------------- -->
      <!-- --------------------------- Footer ----------------------------- -->
      <!-- ---------------------------------------------------------------- -->

      <div class="xmodal-footer">
        <button type="button" @click="CloseModalUpdateCreate" class="btn-danger">
          Cancel
        </button>
        <button id="xmodal-submit-btn-id" type="button" @click="handleEditClickSubmitBtn" class="btn-primary">
          Submit
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { store } from "../../../store/store.js";
import ApplicationGrid from "../../../components/dataSupport/ApplicationGrid.vue"

export default {
  data() {
    return {
      store,

      isActive: null,
      activeNotSelected: false,
      recordsToShow: 'active',
      createSelected: false,

      gridTime: { grid: null, time: null },
      gridCompanyNames: null,

      modalTitle: null,
      rowsPerPageArray: [10, 25, 50, 100, 250],
      validationErrorsFound: false,
      controlWith_large: 30,
      controlWith_small: 15,

      //-------- Specific Record Fields
      companyId: null,
      companyName: null,
      companyAddress1: null,
      companyAddress2: null,
      companyCity: null,
      stateName: null,
      stateList: null,
      defaultState: { usStateId: -1, stateName: 'Please Select a Value' },
      selectedStateId: null,
      countryName: null,
      countryList: null,
      defaultCountry: { countryId: -1, countryName: 'Please Select a Value' },
      selectedCountryID: null,
      companyPostal: null,
      companyPhone: null,
      naisc: null,
      cage: null,
      isActive: null,
      updateDate: null,
      nameUndefined: false,
      nameNotUnique: false,

      headerArrays: [
        { defaultShow: false, rawName: 'companyId', displayName: 'Company ID', hoverText: 'Company ID' },
        { defaultShow: true, rawName: 'companyName', displayName: 'Company Name', hoverText: 'Name of the company' },
        { defaultShow: false, rawName: 'companyAddress1', displayName: 'Address 1', hoverText: 'Address 1' },
        { defaultShow: false, rawName: 'companyAddress2', displayName: 'Address 2', hoverText: 'Optional address 2' },
        { defaultShow: true, rawName: 'companyCity', displayName: 'City', hoverText: 'Company city' },
        { defaultShow: false, rawName: 'stateId', displayName: 'State ID', hoverText: 'Company state database ID' },
        { defaultShow: true, rawName: 'stateAcronym', displayName: 'State Acro', hoverText: 'State Acronym' },
        { defaultShow: false, rawName: 'stateName', displayName: 'State', hoverText: 'Company state' },
        { defaultShow: false, rawName: 'countryId', displayName: 'Country ID', hoverText: 'Company country database ID' },
        { defaultShow: true, rawName: 'countryName', displayName: 'Country', hoverText: 'Company country' },
        { defaultShow: false, rawName: 'acro2', displayName: 'Acro2', hoverText: 'Country 2-digit acronym' },
        { defaultShow: false, rawName: 'acro3', displayName: 'Acro3', hoverText: 'Country 3-digit acronym' },
        { defaultShow: false, rawName: 'companyPostal', displayName: 'Postal Code', hoverText: 'Company postal code' },
        { defaultShow: true, rawName: 'companyPhone', displayName: 'Phone', hoverText: 'Company phone number' },
        { defaultShow: true, rawName: 'naisc', displayName: 'NAICS', hoverText: 'North American Industry Classification System (NAICS)' },
        { defaultShow: true, rawName: 'cage', displayName: 'CAGE', hoverText: 'CAGE Code' },
        { defaultShow: false, rawName: 'isActive', displayName: 'Active', hoverText: 'Is active boolean' },
        { defaultShow: false, rawName: 'updateDate', displayName: 'Update Date', hoverText: 'Date last updated' },
        { defaultShow: false, rawName: 'updatedBy', displayName: 'UpdateBy ', hoverText: 'User ID of who last updated the record' },
        { defaultShow: false, rawName: 'createDate', displayName: 'Create Date', hoverText: 'Date record created' },
        { defaultShow: false, rawName: 'createdBy', displayName: 'CreateBy', hoverText: 'User ID of who created the record' }
      ],

      //leftHeader0,   ..., leftHeader9
      //rightHeader10, ..., rightHeader19
      leftRightSlots: [
        { slot: 'rightHeader10', enableSorting: true, field: 'isActive' },
        { slot: 'rightHeader11', enableSorting: true, field: '__not_specified__' },
      ],

    };
  },
  created() {

    this.getGridData();
    this.getAllCountry();
    this.getAllState();
  },
  computed: {
    UserProfileId() {
      return store.authenticatedUser.userProfileId != null
        ? store.authenticatedUser.userProfileId
        : store.tempUserProfileId;
    },
  },
  components: { ApplicationGrid },
  methods: {

    clearValidationFields() {
      this.$data.nameUndefined = false;
      this.$data.nameNotUnique = false;
      this.$data.validationErrorsFound = false;
      this.$data.activeNotSelected = false;
    },

    CloseModalUpdateCreate() {
      // console.log("OpenModalFnc()");
      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "none";
    },

    databaseCreateCompany() {

      let localActive = this.setFieldsForNull();

      axios
        .post(store.webAPIUrl + "Company/CreateCompany/" +
          this.UserProfileId + '/' +
          this.$data.companyName + "/" +
          this.$data.companyAddress1 + "/" +
          this.$data.companyAddress2 + "/" +
          this.$data.companyCity + "/" +
          this.$data.selectedStateId + "/" +
          this.$data.selectedCountryID + "/" +
          this.$data.companyPostal + "/" +
          this.$data.companyPhone + "/" +
          encodeURIComponent(this.$data.naisc) + "/" +
          this.$data.cage + "/" +
          localActive
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getGridData();
        });
    },


    setFieldsForNull() {

      if (this.$data.companyAddress1 == null) {
        this.$data.companyAddress1 = "__null__";
      } else if (this.$data.companyAddress1.trim().length == 0) {
        this.$data.companyAddress1 = "__null__";
      }
      if (this.$data.companyAddress2 == null) {
        this.$data.companyAddress2 = "__null__";
      } else if (this.$data.companyAddress2.trim().length == 0) {
        this.$data.companyAddress2 = "__null__";
      }
      if (this.$data.companyCity == null) {
        this.$data.companyCity = "__null__";
      } else if (this.$data.companyCity.trim().length == 0) {
        this.$data.companyCity = "__null__";
      }
      if (this.$data.companyPostal == null) {
        this.$data.companyPostal = "__null__";
      } else if (this.$data.companyPostal.trim().length == 0) {
        this.$data.companyPostal = "__null__";
      }
      if (this.$data.companyPhone == null) {
        this.$data.companyPhone = "__null__";
      } else if (this.$data.companyPhone.trim().length == 0) {
        this.$data.companyPhone = "__null__";
      }
      if (this.$data.naisc == null) {
        this.$data.naisc = "__null__";
      } else if (this.$data.naisc.trim().length == 0) {
        this.$data.naisc = "__null__";
      }
      if (this.$data.cage == null) {
        this.$data.cage = "__null__";
      } else if (this.$data.cage.trim().length == 0) {
        this.$data.cage = "__null__";
      }

      let activeYes = document.querySelector('#radioActiveID');
      let localActive = null;
      if (activeYes.checked) {
        localActive = true;
      } else {
        localActive = false;
      }

      if (this.$data.selectedStateId == null) {
        this.$data.selectedStateId = -1;
      }

      if (this.$data.selectedCountryID == null) {
        this.$data.selectedCountryID = -1;
      }

      return localActive;

    },

    databaseUpdateCompany() {

      let localActive = this.setFieldsForNull();

      axios
        .post(store.webAPIUrl + "Company/UpdateCompany/" +
          this.UserProfileId + '/' +
          this.$data.companyId + "/" +
          this.$data.companyName + "/" +
          this.$data.companyAddress1 + "/" +
          this.$data.companyAddress2 + "/" +
          this.$data.companyCity + "/" +
          this.$data.selectedStateId + "/" +
          this.$data.selectedCountryID + "/" +
          this.$data.companyPostal + "/" +
          this.$data.companyPhone + "/" +
          encodeURIComponent(this.$data.naisc) + "/" +
          this.$data.cage + "/" +
          localActive
        )
        .then((response) => response.data)
        .then(() => {
          // console.log(data);
          this.getGridData();
        });
    },

    //Used to format dates passed to the HTML date control.
    formatDateFnc(value) {
      let monthPart = value.substring(0, 2);
      let dayPart = value.substring(3, 5);
      let yearPart = value.substring(6, value.length);
      return monthPart + '/' + dayPart + '/' + yearPart;
    },

    getGridData() {

      axios
        .get(store.webAPIUrl + "Company/SelAllCompanyFull/" + this.$data.recordsToShow)
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridTime = { grid: data, time: new Date().getTime() };
          //This has to be updated for validation.
          this.getCompanyNames();
        });
    },

    getCompanyNames() {
      axios
        .get(store.webAPIUrl + "Company/SelCompanyNames")
        .then((response) => response.data)
        .then((data) => {
          this.$data.gridCompanyNames = data;
          // console.log('this.$data.gridCompanyNames = ', this.$data.gridCompanyNames);
        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllState ---------------------------------------------
    // --------------------------------------------------------------------------

    getAllState() {
      // console.log("ContractRecords.vue getAllCampLocation()");
      axios
        .get(store.webAPIUrl + "State/SelAllState")
        .then((response) => response.data)
        .then((data) => {
          this.$data.stateList = data;
          // console.log("this.$data.CampLocationList: ");
          // console.log(this.$data.CampLocationList);

          //Add the default item to the top of the list.
          this.$data.stateList.unshift(this.$data.defaultState);
          //Make the selection for the dropdown list.
          this.$data.selectedStateId = this.$data.defaultState.usStateId;

          // console.log('getAllState(): this.$data.selectedStateId = ', this.$data.selectedStateId);
          // console.log('getAllState(): this.$data.stateList = ', this.$data.stateList);
        });
    },

    // --------------------------------------------------------------------------
    // ---------------- getAllCountry --------------------------------------
    // --------------------------------------------------------------------------

    getAllCountry() {
      // console.log("ContractRecords.vue getAllCampLocation()");
      axios
        .get(store.webAPIUrl + "Country/SelAllCountry")
        .then((response) => response.data)
        .then((data) => {
          this.$data.countryList = data;
          // console.log("this.$data.CampLocationList: ");
          // console.log(this.$data.CampLocationList);

          //Add the default item to the top of the list.
          this.$data.countryList.unshift(this.$data.defaultCountry);
          //Make the selection for the dropdown list.
          this.$data.selectedCountryID = this.$data.defaultCountry.countryId;

          // console.log('getAllCampLocation(): this.$data.selectedCampLocationId = ', this.$data.selectedCampLocationId);
        });
    },

    //This is called in response to clicking the Active/Inactive links.
    handleActiveLinkClick(args) {

      let companyid = args.itemArg["companyId"];

      let newActive = false;
      if (args.itemArg["isActive"] == false) {
        newActive = true;
      }

      this.UpdateRecordActiveState(companyid, newActive);

    },

    handleActiveRadioClick() {
      this.$data.recordsToShow = 'active';

      this.getGridData();
    },

    handleAllRadioClick() {
      this.$data.recordsToShow = 'all';

      this.getGridData();
    },

    //This is called in response to clicking the create div.The dialog
    //modal is opened due to properties set in the edit div. 
    handleCreateRecord() {
      // console.log('-->> handleCreateRecord()');
      this.$data.createSelected = true;
      this.clearValidationFields();

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      let yesRadioButton = document.querySelector('#radioActiveID');
      let noRadioButton = document.querySelector('#radioInactiveID');

      yesRadioButton.checked = false;
      noRadioButton.checked = false;

      this.$data.modalTitle = 'Create Company Record';

      this.$data.companyName = null;
      this.companyAddress1 = null;
      this.companyAddress2 = null;
      this.companyCity = null;
      this.companyPostal = null;
      this.companyPhone = null;
      this.naisc = null;
      this.cage = null;

      this.$data.selectedCountryID = this.$data.defaultCountry.countryId;
      this.$data.selectedStateId = this.$data.defaultState.usStateId;
    },

    //This method is called when clicking on the submit button
    //in the update modal.
    handleEditClickSubmitBtn() {

      this.validateFields();

      if (this.$data.validationErrorsFound == false) {

        let modalWindow = document.querySelector("#xmodal-main-ID");
        modalWindow.style.display = "none";

        if (this.$data.createSelected == true) {
          this.databaseCreateCompany();
        } else {
          this.databaseUpdateCompany();
        }
      }

    },

    //This is called in response to clicking the pencil icon for a record. The dialog
    //modal is opened due to properties set in the edit div. 
    handleEditRecord(args) {

      this.$data.createSelected = false;
      //this.clearValidationFields();

      //These will be used the modal window.

      this.$data.companyId = args.itemArg["companyId"];

      this.$data.companyId = args.itemArg["companyId"];
      this.$data.companyName = args.itemArg["companyName"];
      this.$data.companyAddress1 = args.itemArg["companyAddress1"];
      this.$data.companyAddress2 = args.itemArg["companyAddress2"];
      this.$data.companyCity = args.itemArg["companyCity"];
      this.$data.stateName = args.itemArg["stateName"];
      this.$data.countryName = args.itemArg["countryName"];
      this.$data.companyPostal = args.itemArg["companyPostal"];
      this.$data.companyPhone = args.itemArg["companyPhone"];
      this.$data.naisc = args.itemArg["naisc"];
      this.$data.cage = args.itemArg["cage"];
      this.$data.isActive = args.itemArg["isActive"];
      this.$data.updateDate = args.itemArg["updateDate"];

      //Set the selected State and Country Location.
      this.$data.selectedCountryID = args.itemArg["countryId"];
      this.$data.selectedStateId = args.itemArg["stateId"];

      if (this.$data.selectedCountryID == null) {
        this.$data.selectedCountryID = -1;
      }

      if (this.$data.selectedStateId == null) {
        this.$data.selectedStateId = -1;
      }

      // console.log('#1 this.$data.selectedCountryID = ', this.$data.selectedCountryID);
      // console.log('#2 this.$data.selectedStateId = ', this.$data.selectedStateId);
      console.log('active state  = ', this.$data.isActive);

      this.$data.modalTitle = 'Edit Company Record';

      let modalWindow = document.querySelector("#xmodal-main-ID");
      modalWindow.style.display = "block";

      let yesRadioButton = document.querySelector('#radioActiveID');
      let noRadioButton = document.querySelector('#radioInactiveID');

      if (this.$data.isActive == true) {
        yesRadioButton.checked = true;
        noRadioButton.checked = false;
      } else {
        yesRadioButton.checked = false;
        noRadioButton.checked = true;
      }

    },

    UpdateRecordActiveState(companyId, recordsToShow) {

      axios
        .get(store.webAPIUrl + "Company/UpdateCompanyActive/"
          + this.UserProfileId + '/'
          + companyId + '/'
          + recordsToShow)
        .then((response) => response.data)
        .then(() => {
          this.getGridData();
        });
    },

    validateActiveState() {
      let yesRadioButton = document.querySelector('#radioActiveID');
      let noRadioButton = document.querySelector('#radioInactiveID');

      if ((yesRadioButton.checked == false) && (noRadioButton.checked == false)) {
        this.$data.validationErrorsFound = true;
        this.$data.activeNotSelected = true;
      }

    },

    validateCompanyName() {
      if (this.$data.companyName == null) {
        this.$data.nameUndefined = true;
        this.$data.validationErrorsFound = true;
      } else if (this.$data.companyName.trim().length == 0) {
        this.$data.nameUndefined = true;
        this.$data.validationErrorsFound = true;
      } else {

        for (let i = 0; i < this.$data.gridCompanyNames.length; i++) {
          let companyName = this.$data.gridCompanyNames[i]['companyName'];
          let companyID = this.$data.gridCompanyNames[i]['companyId'];

          let trimmedOriginalName = companyName.trim().toLowerCase();
          let trimmedNewName = this.$data.companyName.trim().toLowerCase();

          if (this.$data.createSelected == false) {
            if ((trimmedOriginalName === trimmedNewName) && (this.$data.companyId != companyID)) {
              this.$data.nameNotUnique = true;
              this.$data.validationErrorsFound = true;
              break;
            }
          } else {
            if (trimmedOriginalName === trimmedNewName) {
              this.$data.nameNotUnique = true;
              this.$data.validationErrorsFound = true;
              break;
            }
          }

        }
      }

    },

    validateFields() {

      this.clearValidationFields();

      this.validateCompanyName();

      if (this.$data.createSelected == true) {
        this.validateActiveState();
      }
    },

  },
};
</script>

<style scoped>
/* ----------------- page ------------------------ */

.mainPageDiv {
  margin-top: 0px;
  margin-left: 0px;
  margin-bottom: 0px;
  padding-right: 0px;
  text-align: left;
  width: 100%;
}

.vertAlignMiddle {
  vertical-align: middle;
}

.radioButtonLeftMargin {
  margin-left: 10px;
}

.labelAlign {
  vertical-align: middle;
  padding: 0px;
  margin: 0px;
  padding-left: 5px;
}

/* -----------------  slots ------------------------ */

.activeAgency {
  margin-left: 20px;
  display: inline-block;
}

.activeInactiveString {
  display: inline-block;
  width: 50px;
}

.spanLink {
  text-decoration: underline;
  cursor: pointer;
}

.editIconSlot {
  margin: 0px;
  font-size: 20px;
  margin-left: 10px;
  vertical-align: middle;
  cursor: pointer;
}

.actionsHeader {
  padding: 0px;
  margin: 0px;
  margin-left: 0px;
}

/* --------------- page header ----------- */

.subHeaderFont {
  font-size: 18px;
}

.pageHeader {
  font-size: 24px;
}

.forIconNewRecord {
  margin-left: 5px;
  cursor: pointer;
  font-size: 24px;
  vertical-align: middle;
}

.radioFirstLeftMargin {
  margin-left: 40px;
}

.radioOtherLeftMargin {
  margin-left: 20px;
}

.radioheaderadjustment {
  padding: 5px;
  margin-top: 5px;
  display: inline-block;
}

.lableMargin {
  margin-left: 5px;
}

/* -------------------------------------------------------------- */
/* ------------------- start modal style ------------------------ */
/* -------------------------------------------------------------- */

.cancelButton {
  background: #6d757c;
  color: white;
  border-radius: 6px;
  margin-left: 10px;
  cursor: pointer;
}

.cancelButton:Hover {
  background: #4e5257;
  color: white;
}

option:first-of-type {
  color: blue;
}

/* ---------- containers ---------- */

.headerMainContainer {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 10% 80% 10%;
}

.cancelModalX {
  cursor: pointer;
}

.xmodal-container-main {
  display: none;
  /* Hidden by default */
  position: fixed;
  /* Stay in place */
  z-index: 1;
  /* Sit on top */
  padding-top: 10px;
  /* Location of the box */
  left: 0;
  top: 0;
  width: 100%;
  /* Full width */
  height: 100%;
  /* Full height */

  /* Enable scroll if needed */
  background-color: rgb(0, 0, 0);
  /* Fallback color */
  background-color: rgba(0, 0, 0, 0.4);
  /* Black w/ opacity */
}

.xmodal-container-form {
  margin: 5px;
  display: grid;
  grid-template-columns: 25% 75%;
  align-items: center;
  justify-content: center;

  /* background-color: lightyellow; */
}

.xmodal-container-content {
  background-color: #fefefe;
  margin: auto;

  padding: 20px;
  border: 1px inset black;

  width: 25%;
  height: 90%;

  min-height: 500px;
  max-height: 720px;

  min-width: 900px;

  margin-bottom: 250px;
  overflow-x: auto;
}

/* ---------- header and footer ---------- */

.xmodal-footer {
  text-align: center;
}

/* ---------- buttons ---------- */

.xmodal-button-Radius {
  border-radius: 6px;
}

/* **** cancel btn */

.xmodal-cancelButton {
  cursor: pointer;
}

/* **** submit btn */

.xmodal-yesSubmitButton {
  margin-left: 10px;
  cursor: pointer;
}

.xmodal-yesSubmitButton:hover {
  background-color: rgb(19, 64, 0);
  color: white;
}

/* ---------- hr separators ---------- */

.xmodal-hr-top {
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

.xmodal-hr-bottom {
  margin-top: 20px;
  margin-bottom: 20px;
  background-color: #E6E6E6;
}

/* ---------- validation ---------- */

.xmodal-outer-div {
  margin: 5px;
  display: grid;
  grid-template-columns: 80%;
  align-items: center;
  justify-content: center;
}

.xmodal-inner-div {
  margin: 0 auto;
}

.xmodal-li-validation {
  text-align: left;
  margin-top: 15px;
  color: black;
  width: 400px;
}

.xmodal-required-asterisk {
  margin-left: 2px;
  font-size: x-large;
}

/* ---------- content elements ---------- */

.xmodal-textbox-padding {
  padding: 5px;
}

.xmodal-control-labels {
  display: flex;
  align-items: center;
  font-weight: 400;
  color: rgb(2, 2, 175);
}

.xmodal-content-justify-right {
  display: flex;
  justify-content: right;
  padding-right: 10px;
}

.xmodal-content-justify-left {
  display: flex;
  justify-content: left;
  align-items: center;
}

.xmodal-dropdownlist-padding {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-right: 5px;
}

/* --------------------------------------------- */
/* -------------- end Modal style -------------- */
/* --------------------------------------------- */
</style>
